import Topic from './Topic';
import TopicsList from './TopicsList';
import TopicOnlyQuiz from './TopicOnlyQuiz';
import ExamPrepTopic from './ExamPrepTopic';

export const containers = {
  Topic,
  TopicsList,
  TopicOnlyQuiz,
  ExamPrepTopic,
};



// WEBPACK FOOTER //
// ./src/modules/topic/containers/index.js